import { UserVehicle } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useUserVehicle = (
  userId: number | undefined,
  vehicleId: string | undefined
): UserVehicle | undefined => {
  const { vehicleStore } = useStore();
  const { userVehicle } = vehicleStore;

  useEffect(() => {
    userId && vehicleId && vehicleStore.getUserVehicle({ userId, vehicleId });

    return () => {
      vehicleStore.resetUserVehicle();
    };
  }, [vehicleStore, userId, vehicleId]);

  return userVehicle;
};
